define('shoptheme/components/contentbridge/accordeon',[
	"jquery",
	"cartware/components/_base"
], function(
	$,
	Component
) {
	return Component.create({
		blocks:			null,

		$init: function() {
			this.blocks = $(".b_contentbridge .accordion");
			this.blocks.each(function() {
				var items = $(this).find(".accordion-item");
				items.each(function(i) {
					var item = $(this),
						title = item.find(".accordion-title"),
						content = item.find(".accordion-content");

					if (0 === i) {
						content.slideDown(0);
					}

					title.on("click", function() {
						items.find(".accordion-content:visible").slideUp();
						content.slideToggle();
					});
				});
			});
		}
	});
});
